import {
  ChangeDetectionStrategy,
  Component,
  inject,
  PLATFORM_ID,
  Renderer2,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { CheckUpdateService } from './shared/services/update/check-update.service';
import pack from '../../package.json';
import { AsyncPipe, isPlatformBrowser } from '@angular/common';
import { ModalContainerService } from './shared/services/modal-container.service';
import { ModalContainerComponent } from './shared/components/ui-components/modal-container/modal-container.component';
import { ThemeService } from 'src/app/common/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [AsyncPipe, ModalContainerComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent implements OnInit {
  updateService = inject(CheckUpdateService); // do not remove
  private modalContainerService = inject(ModalContainerService);
  private platformId = inject(PLATFORM_ID);
  private renderer = inject(Renderer2);
  private themeService = inject(ThemeService);

  showModals$ = this.modalContainerService.showModals$;

  title = 'enrollhere-payments';

  version = pack.version;

  ngOnInit() {
    this.themeService.primaryColor$.subscribe();
    this.loadHeapScript(environment.heapEnvId);
  }

  private loadHeapScript(envId: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const script = this.renderer.createElement('script');
      script.type = 'text/javascript';
      script.text = `
      window.heapReadyCb = window.heapReadyCb || [];
      window.heap = window.heap || [];
      heap.load = function(e, t) {
        window.heap.envId = e;
        window.heap.clientConfig = t = t || {};
        window.heap.clientConfig.shouldFetchServerConfig = !1;
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.async = !0;
        a.src = "https://cdn.us.heap-api.com/config/" + e + "/heap_config.js";
        var r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(a, r);
        var n = [
          "init", "startTracking", "stopTracking", "track", "resetIdentity", "identify", "getSessionId", "getUserId", "getIdentity",
          "addUserProperties", "addEventProperties", "removeEventProperty", "clearEventProperties", "addAccountProperties",
          "addAdapter", "addTransformer", "addTransformerFn", "onReady", "addPageviewProperties", "removePageviewProperty",
          "clearPageviewProperties", "trackPageview"
        ];
        var i = function(e) {
          return function() {
            var t = Array.prototype.slice.call(arguments, 0);
            window.heapReadyCb.push({
              name: e,
              fn: function() {
                heap[e] && heap[e].apply(heap, t);
              }
            });
          };
        };
        for (var p = 0; p < n.length; p++) heap[n[p]] = i(n[p]);
      };
      heap.load("${envId}", { disableTextCapture: false });
    `;
      this.renderer.appendChild(document.body, script);
    }
  }
}
